<template>
<div class="popup_overlay">
  <div class="custom_dialog_comp bg-white h-full" style="width:100%">
    <div class="cust_card_comp">
      <div class=" rounded px-5 py-4 h-full bg-primary text-white heading-2 font-bold flex items-center justify-between">
        <div>
          <p class="">left_or_right_image</p>
        </div>
        <div>
          <button class="list_top_card_btn font-bold bg-gray-200 cta-text text-text1 py-2 px-4 mr-2 rounded-3xl" @click="closeDetails(false)">Discard</button>
          <button class="list_top_card_btn font-bold  bg-success cta-text text-white py-2 px-4 rounded-3xl" @click="saveData()">Save</button>
        </div>  
      </div>
  <div class="p-0 bg-white" >
    <div class="bg-white p-2">
      <div class="pt-2 px-1 grid grid-cols-2 gap-x-2">
        <div class="box bg-white h-full cust_card">
          <div class="py-2 px-1 grid  gap-x-2">
            <p class="label_css pl-4 font-bold">left_or_right_image_list</p>
           <div v-for="(data, index) in fieldJsonData.left_or_right_image_list" :key="index" class="px-2 pb-0 grid grid-cols-12">
                <div class="box col-span-12 p-2 pb-0">
                    <p class="label_css">heading</p>
                    <textarea v-model="data.heading"
                    :class="errorArray[index].heading_err && data.heading === '' ? 'border border-error' : ''"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="heading"
                    ></textarea>
                    <p v-if="errorArray[index].heading_err && data.heading === ''" class="text-error heading-6">heading is required</p>
                </div>
                <div v-if="tempCardDescriptionIndex !== index" class="box col-span-12 p-2 pb-0" :class="componentDetailsForEdit !== null ? '' : 'mt-4'">
                <label class="label_css font-bold cursor-pointer" style="color: #1976D3" @click="openCardListDescription(index)">{{componentDetailsForEdit !== null ? "+ Edit Description" : "+ Add Description"}}</label>
                <p v-if="componentDetailsForEdit !== null" v-html="data.description"></p>
                <p v-if="errorArray[index].description_err" class="text-error heading-6">description is required</p>
                </div>
                <div v-if="tempCardDescriptionIndex === index && cardDescriptionEditor === false" class="box col-span-12 p-2 pb-0">
                    <p class="label_css">description</p>
                    <editor v-model="data.description"
                    :class="errorArray[index].description_err && data.description === '' ? 'border border-error' : ''"
                    placeholder="description"
                    ></editor>
                    <p v-if="errorArray[index].description_err && data.description === ''" class="text-error heading-6">description is required</p>
                </div>
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">background_color</p>
                    <textarea v-model="data.background_color"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="background_color"
                    ></textarea>
                </div>
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">r_img_url</p>
                    <textarea v-model="data.r_img_url"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="r_img_url"
                    ></textarea>
                </div>
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">r_img_alt</p>
                    <textarea v-model="data.r_img_alt"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="r_img_alt"
                    ></textarea>
                </div>
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">l_img_url</p>
                    <textarea v-model="data.l_img_url"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="l_img_url"
                    ></textarea>
                </div>
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">l_img_alt</p>
                    <textarea v-model="data.l_img_alt"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="l_img_alt"
                    ></textarea>
                </div>
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">cta_text</p>
                    <textarea v-model="data.cta_text"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="cta_text"
                    ></textarea>
                </div>
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">cta_url</p>
                    <textarea v-model="data.cta_url"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="cta_url"
                    ></textarea>
                </div>
                <div class="col-span-6 mt-2 p-2 pb-0">
                    <p class="label_css">cta_in_new_tab</p>
                    <div class="flex items-center pb-1 ">
                    <input :id="`default-radio-3-${index}`" v-model="data.cta_in_new_tab" type="radio" :value="false" :name="`default-radio-3-${index}`" class="w-5 h-5 text-primary bg-gray-100 border-gray-300 outline-none cursor-pointer">
                    <label :for="`default-radio-3-${index}`" class="ml-2 heading-4 text-text2  dark:text-gray-300 cursor-pointer">No</label>
                    </div>
                    <div class="flex items-center pb-1 col-span-6">
                    <input :id="`default-radio-4-${index}`" v-model="data.cta_in_new_tab" type="radio" :value="true" :name="`default-radio-4-${index}`" class="w-5 h-5 text-primary bg-gray-100 border-gray-300 outline-none cursor-pointer">
                    <label :for="`default-radio-4-${index}`" class="ml-2 heading-4 text-text2  dark:text-gray-300 cursor-pointer">Yes</label>
                    </div>
               </div>
                <div class="box col-span-12 p-1 mt-3">
                <div class="flex justify-end">
                  <button v-if="index !== 0" class=" rounded-full h-8 w-8 bg-error  mr-1"
                    @click="removeCardDetails(index)"
                    >
                    <i class="fas fa-minus text-white heading-3"></i>
                  </button>
                  <button v-if="index === fieldJsonData.left_or_right_image_list.length - 1" class=" rounded-full h-8 w-8 bg-primary"
                  @click="addCardDetails()"
                    >
                    <i class="fas fa-plus text-white heading-3"></i>
                  </button>
                </div>
              </div>
                <div v-if="fieldJsonData.left_or_right_image_list.length - 1 !== index" class="mt-4 col-span-12" style="border: 1px solid gray; border-style: dashed"></div>
             </div>
          </div>
          <!-- <div class="p-2 pb-5 text-right">
            <div>
              <button class="list_top_card_btn bg-gray-200 cta-text text-text1 py-2 px-4 mr-2 rounded-3xl">Discard</button>
              <button class="list_top_card_btn bg-primary cta-text text-white py-2 px-4 mr-2 rounded-3xl" @click="saveData()">Save</button>
            </div>  
          </div> -->
        </div>
        <div>
        <img style="padding: 1px"  class="box border-1 shadow-lg rounded-lg" :src="componentImageUrl" :alt="componentImageUrl" />
      </div>
      </div>
    </div>
  </div>
    </div>
  </div>
</div>
</template>
<script>
import Editor from '../../../../../../components/editor.vue'
// import draggable from 'vuedraggable'
// import HRM from '@/View/CMS/api/HRM.js'
export default {
  components: {
    Editor
    // draggable,
  },
  props: ['componentDetailsForEdit', 'fieldJsonData', 'componentImageUrl', 'componentId'],
  data () {
    return {
      isError: true,
      cardDescriptionEditor: false,
      tempCardDescriptionIndex: null,
      // fieldJsonData: {
      //   component_name: "fieldJsonData",
      //   left_or_right_image_list: [
      //       {
      //       heading: "",
      //       heading_err: false,
      //       description: "",
      //       description_err: false,
      //       }
      //   ]
      // }
      errorArray: [
        {
          heading_err: false,
          description_err: false
        }
      ]
    }
  },
  created() {
    if (this.componentDetailsForEdit !== null) {
      console.log("componentDetailsForEdit!!!!!!!!!!!fieldJsonData", this.componentDetailsForEdit)
      this.fieldJsonData = this.componentDetailsForEdit
      console.log("this.fieldJsonData", this.fieldJsonData)
      for (let index = 0; index < this.fieldJsonData.left_or_right_image_list.length; index++) {
        let obj = {
          heading_err: false,
          description_err: false
        }
        this.errorArray.push(obj)
      }
    }
  },
  mounted () {
    // for (let index = 0; index < this.fieldJsonData.left_or_right_image_list.length; index++) {
    //   let obj = {
    //     heading: this.fieldJsonData.left_or_right_image_list[index].heading,
    //     description: this.fieldJsonData.left_or_right_image_list[index].description
    //   }
    //   let errObj = {
    //     heading_err: false,
    //     description_err: false
    //   }
    //   this.fieldJsonData.left_or_right_image_list.push(obj)
    //   this.errorArray.push(errObj)
    // }
  },
  watch: {
    fieldJsonData: {
      handler () {
        console.log('fieldJsonData 123', this.fieldJsonData)
        for (let index = 0; index < this.fieldJsonData.left_or_right_image_list.length; index++) {
          for (let i = 0; i < this.errorArray.length; i++) {
            if (index === i) {
              if (this.fieldJsonData.left_or_right_image_list[index].heading !== '') {
                this.errorArray[i].heading_err = false
                this.isError = false
              }
              if (this.fieldJsonData.left_or_right_image_list[index].description !== '') {
                this.errorArray[i].description_err = false
                this.isError = false
              }
            }
          }
        }
      },
      deep: true
    }
  },
  methods: {
    openCardListDescription (index) {
      this.tempCardDescriptionIndex = index
    },
    addCardDetails () {
      this.fieldJsonData.left_or_right_image_list.push({
        heading: "",
        description: "",
        r_img_url: "",
        r_img_alt: "",
        l_img_url: "",
        l_img_alt: "",
        background_color: "",
        cta_text: "",
        cta_url: "",
        cta_in_new_tab: false
      })
      console.log("addddddd", this.fieldJsonData.left_or_right_image_list);
      this.errorArray.push(
        {
          heading_err: false,
          description_err: false
        }
      )
    },
    removeCardDetails (index) {
      if (this.fieldJsonData.left_or_right_image_list.length !== 1) {
        this.fieldJsonData.left_or_right_image_list.splice(index, 1)
      }
      console.log("removeeeeeee", this.fieldJsonData.left_or_right_image_list);
    },
    saveData() {
      // this.fieldJsonData.left_or_right_image_list[0]['heading_err'] = false,
      // this.fieldJsonData.left_or_right_image_list[0]['description_err'] = false
      console.log("componentDetailsForEdit", this.componentDetailsForEdit)
      for (let index = 0; index < this.fieldJsonData.left_or_right_image_list.length; index++) {
          for (let i = 0; i < this.errorArray.length; i++) {
            if (index === i) {
              if (this.fieldJsonData.left_or_right_image_list[index].heading === '') {
                this.errorArray[i].heading_err = true
                this.isError = true
              }
              if (this.fieldJsonData.left_or_right_image_list[index].description === '') {
                this.errorArray[i].description_err = true
                this.isError = true
              }
            }
          }
        }
      if (this.isError === false) {
        // for (let index = 0; index < this.fieldJsonData.left_or_right_image_list.length; index++) {
        //     delete this.fieldJsonData.left_or_right_image_list[index].heading_err
        //     delete this.fieldJsonData.left_or_right_image_list[index].description_err
        // }
        this.$emit('objData', this.fieldJsonData)
        this.componentDetailsForEdit = null
        let compIdImage = {
          imageUrl: this.componentImageUrl,
          id: this.componentId
        }
        // this.$emit('imageData', this.componentImageUrl)
        this.$emit('compIdImage', compIdImage)
        this.$root.$emit('closeComponentDialog', true)
        console.log("this.fieldJsonData............", this.fieldJsonData)
      }
    },
    closeDetails () {
    this.$root.$emit('closeComponentDialog', true)
    },
  },
  beforeDestroy () {
  }
}
</script>
<style scoped>
/* .list_top_card_btn {
  width: 163px !important;
  margin-right: 15px !important;
} */

::placeholder {
  font-size: 16px;
}
</style>